import { useState, useEffect } from "react";
import { X, Warning } from "@phosphor-icons/react";

export function FalseLeadDialog({ open, onClose, onConfirm }) {
    const [reason, setReason] = useState("");

    useEffect(() => { if (open) setReason(""); }, [open]);

    if (!open) return null;

    const submit = (e) => {
        e.preventDefault();
        if (!reason.trim()) return;
        onConfirm(reason.trim());
    };

    return (
        <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4"
            data-testid="false-lead-dialog">
            <div className="bg-white border border-border rounded-sm w-full max-w-md">
                <div className="flex items-start justify-between p-5 border-b border-border">
                    <div className="flex items-center gap-2">
                        <Warning size={20} className="text-signal-warning" weight="fill" />
                        <div>
                            <div className="overline text-muted-foreground">Drop lead</div>
                            <h3 className="font-heading text-xl font-bold mt-1">Why are you dropping this lead?</h3>
                        </div>
                    </div>
                    <button onClick={onClose} data-testid="false-lead-close" className="text-muted-foreground hover:text-foreground">
                        <X size={18} />
                    </button>
                </div>
                <form onSubmit={submit} className="p-5">
                    <p className="text-sm text-muted-foreground mb-3">
                        Tell us what went wrong — we'll use this to refine future lead discovery.
                    </p>
                    <textarea
                        data-testid="false-lead-reason"
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        rows={4}
                        autoFocus
                        required
                        className="input-os resize-none"
                        placeholder="e.g. Wrong industry, company doesn't exist, no decision-maker, already a competitor, etc."
                    />
                    <div className="flex justify-end gap-2 mt-4">
                        <button type="button" onClick={onClose} className="btn-secondary text-sm">
                            Cancel
                        </button>
                        <button type="submit" data-testid="false-lead-submit" className="btn-primary text-sm">
                            Drop lead
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
